export const getNextYearDate = () => {
	let newDate = new Date()
	newDate.setDate(newDate.getDate() + 1)
	const date = newDate.getDate()
	const month = newDate.getMonth() + 1
	const year = newDate.getFullYear() + 1
	return `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : date}`
}